import screenfull from 'screenfull';
import bean from 'bean';
import assetsLoader from 'assets-loader';
const random = require("random-js")();

import './index.scss';
import * as constants from './constants';

import Video from './video';
import texts from './texts';

const KING_ITEMS = random.shuffle([
  constants.ITEM_LOSINI,
  constants.ITEM_SNAKE,
  constants.ITEM_PISTOL,
]);

class App {
  dom = {};
  ctx = null;
  gameState = constants.GAME_STATE_INITIAL_LOADING;
  wasGameStarted = false;
  kingItem = null;
  kingItemPickingIndex = 0;
  hamletItem = null;
  canSelectHamletItem = false;
  timerDuration = 0;
  timerStartTime = 0;
  timerFinished = false;
  playingVideo = null;
  mainActionStarted = false;
  loadedVideos = {};


  constructor({
    rootEl,
  }) {
    this.cacheDomEls(rootEl);
    this.preRun();
  }

  cacheDomEls(rootEl) {
    const {dom} = this;

    dom.rootEl = rootEl;
    dom.loaderEl    = rootEl.querySelector('.App-loader');
    dom.containerEl = rootEl.querySelector('.App-container');
    dom.timerEl     = rootEl.querySelector('.App-timer');

    dom.startSceneEl            = rootEl.querySelector('.App-startScene');
    dom.startSceneLogoEl        = dom.startSceneEl.querySelector('.App-logo');
    dom.startSceneStartButtonEl = dom.startSceneEl.querySelector('.App-startButton');

    dom.selectionSceneEl    = rootEl.querySelector('.App-selectionScene');
    dom.selectionItemsEl    = rootEl.querySelector('.App-selectionItems');
    dom.selectionItemElArr  = dom.selectionItemsEl.querySelectorAll('.App-selectionItem');

    dom.endSceneEl              = rootEl.querySelector('.App-endScene');
    dom.endSceneLogoEl          = dom.endSceneEl.querySelector('.App-logo');
    dom.endSceneTextEl          = dom.endSceneEl.querySelector('.App-endText');
    dom.endScenePlayAgainButton = dom.endSceneEl.querySelector('.App-playAgainButton');
  }

  loadMainAssets() {
    return new Promise((resolve, reject) => {
      const loader = assetsLoader({
        assets: [
          {url: 'assets/i/start.jpg'},
          {url: 'assets/i/final.jpg'},

          {url: 'assets/i/item_ban.png'},
          {url: 'assets/i/item_fen.png'},
          {url: 'assets/i/item_tuf.png'},
          {url: 'assets/i/item_van.png'},
          {url: 'assets/i/item_yad.png'},

          {url: 'assets/music/main_menu_song.mp3'},
          {url: 'assets/music/final_song.mp3'},
        ]
      });

      loader.on('error', error => reject(error));
      loader.on('complete', () => resolve());

      loader.start();
    });
  }

  showContainer() {
    return new Promise((resolve) => {
      const {loaderEl, containerEl} = this.dom;
      this.removeIsVisible(loaderEl).then(() => {
        this.addIsVisible(containerEl).then(() => {
          resolve();
        });
      });
    });
  }

  onLoadMainAssetsError = error => {
    console.error(error);
  };

  addIsVisible(el, duration = 500) {
    return new Promise((resolve) => {
      el.style.visibility = 'visible';
      setTimeout(() => {
        el.classList.remove('is-visible_no');
        el.classList.add('is-visible_yes');
        if (duration === 0) {
          resolve();
        } else {
          setTimeout(() => {
            resolve();
          }, duration);
        }
      });
    });
  }

  removeIsVisible(el, duration = 500) {
    return new Promise((resolve) => {
      el.classList.remove('is-visible_yes');
      el.classList.add('is-visible_no');
      if (duration === 0) {
        el.style.visibility = 'hidden';
        resolve();
      } else {
        setTimeout(() => {
          el.style.visibility = 'hidden';
          resolve();
        }, duration);
      }
    });
  }

  bindEvents() {
    const body = document;
    const {
      startSceneStartButtonEl,
      endScenePlayAgainButton,
      selectionItemElArr,
    } = this.dom;
    bean.on(body, 'keypress', this.onBodyKeypress);
    bean.on(window, 'resize', () => {
      this.resizeAll();
    });
    bean.on(startSceneStartButtonEl, 'click', this.onStartSceneButtonClick);
    bean.on(endScenePlayAgainButton, 'click', this.onEndScenePlayAgainButtonClick);
    [].forEach.call(selectionItemElArr, (el) => {
      bean.on(el, 'click', this.onSelectionItemClick);
    });
  }

  onStartSceneButtonClick = event => {
    this.startGame();
  };

  onEndScenePlayAgainButtonClick = event => {
    this.startGame();
  };

  onSelectionItemClick = event => {
    event.preventDefault();
    const el = event.currentTarget;
    if (el.classList.contains('is-fen')) {
      this.selectHamletItem('fen');
    }
    else if (el.classList.contains('is-ban')) {
      this.selectHamletItem('ban');
    }
    else if (el.classList.contains('is-tuf')) {
      this.selectHamletItem('tuf');
    }
    else if (el.classList.contains('is-van')) {
      this.selectHamletItem('van');
    }
    else if (el.classList.contains('is-yad')) {
      this.selectHamletItem('yad');
    }
  };

  onBodyKeypress = (event) => {
    event.preventDefault();
    if (event.keyCode === constants.KEY_CODE_ENTER) {
      if (screenfull.enabled) {
        screenfull.request();
      }
    }

    const {keyCode} = event;
    [
      [constants.KEY_CODE_A, constants.ITEM_FEN],
      [constants.KEY_CODE_S, constants.ITEM_BANAN],
      [constants.KEY_CODE_D, constants.ITEM_TUFLYA],
      [constants.KEY_CODE_F, constants.ITEM_VANTUZ],
      [constants.KEY_CODE_G, constants.ITEM_YAD],
    ].forEach(data => {
      const [itemKeyCode, item] = data;
      if (itemKeyCode == keyCode) {
        this.selectHamletItem(item.name);
      }
    });

    if (keyCode === constants.KEY_CODE_SPACE) {
      this.startGame();
    }
  };

  resizeAll = () => {
    const {canvasEl} = this.dom;

    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    const videoWidth = 1280;
    const videoHeight = 720;

    let width = window.innerWidth;
    let height = videoHeight / (videoWidth/width);

    if (height > windowHeight) {
      height = windowHeight;
      width = height * videoWidth / videoHeight;
    }

    // Firefox currently has a bug where the canvasHeight can't be read from
    // the video, so we will make assumptions if this happens.

    if (isNaN(height)) {
      height = width / (4/3);
    }

    [].forEach.call(document.querySelectorAll('video'), el => {
      el.setAttribute('width', width);
      el.setAttribute('height', height);
    });
  };

  preRun() {
    this.loadMainAssets().then(() => {
      this.bindEvents();
      this.resizeAll();
      this.addIsVisible(this.dom.startSceneEl, 0).then(() => {
        this.showContainer().then(() => {
          this.run();
        });
      });
    }).catch(this.onLoadMainAssetsError);
  }

  showStartScene() {
    const {
      startSceneEl,
      selectionSceneEl,
      endSceneEl,
    } = this.dom;

    return this.removeIsVisible(endSceneEl).then(() => {
      this.addIsVisible(startSceneEl);
    });
  }

  showSelectionScene() {
    const {
      startSceneEl,
      selectionSceneEl,
      endSceneEl,
    } = this.dom;
    return this.removeIsVisible(startSceneEl).then(() => {
      this.addIsVisible(selectionSceneEl);
    });
  }

  showEndScene() {
    const {
      startSceneEl,
      selectionSceneEl,
      endSceneEl,
    } = this.dom;
    return this.removeIsVisible(selectionSceneEl).then(() => {
      this.addIsVisible(endSceneEl);
    });
  }

  run() {
    this.render();
  }

  startGame() {
    if (this.wasGameStarted) {
      return;
    }
    if (this.finalSceneAudio) {
      this.finalSceneAudio.pause();
    }
    if (this.menuSceneAudio) {
      this.menuSceneAudio.pause();
    }
    this.wasGameStarted = true;

    const {
      startSceneEl,
      endSceneEl,
    } = this.dom;

    this.createKingItem();
    this.playIntro().then(() => {
      this.showSelectionScene().then(() => {
        this.startTimer();
        this.enableHamletItemSelection();
      });
    });

    Promise.all([this.removeIsVisible(startSceneEl), this.removeIsVisible(endSceneEl)]).then(() => {

    });
  }

  enableHamletItemSelection() {
    this.canSelectHamletItem = true;
  }

  disableHamletItemSelection() {
    this.canSelectHamletItem = false;
  }

  createKingItem() {
    const item = KING_ITEMS[this.kingItemPickingIndex % KING_ITEMS.length];
    this.kingItemPickingIndex++;
    this.kingItem = item;
  }

  selectHamletItem(hamletItem) {
    if (!this.canSelectHamletItem || this.hamletItem) {
      return;
    }
    this.hamletItem = hamletItem;
    this.disableHamletItemSelection();
    this.startAction();
  }

  playIntro() {
    const introVideo  = new Video({filePath: this.getVideoPath({type: 'intro', kingItem: this.kingItem})});
    const loopVideo   = new Video({filePath: this.getVideoPath({type: 'loop', kingItem: this.kingItem})});
    const winVideo    = new Video({filePath: this.getVideoPath({type: 'win', kingItem: this.kingItem})});

    const allVideosLoaded = (
      this.loadedVideos[introVideo.filePath] &&
      this.loadedVideos[loopVideo.filePath] &&
      this.loadedVideos[winVideo.filePath]
    );
    if (!allVideosLoaded) {
      this.showLoader();
    }
    return new Promise((resolve, reject) => {
      Promise.all([introVideo.load(), loopVideo.load(), winVideo.load()]).then(() => {
        this.resizeAll();
        this.loadedVideos[introVideo.filePath] = introVideo;
        this.loadedVideos[loopVideo.filePath] = loopVideo;
        this.loadedVideos[winVideo.filePath] = winVideo;

        const afterVideosLoaded = () => {
          introVideo.play().then(() => {
            this.setPlayingVideo(loopVideo);
            loopVideo.playWithLoop({
              loopEndDuration: 90,
            });
            resolve();
          });
          this.setPlayingVideo(introVideo);
          this.addIsVisible(this.playingVideo.el).then(() => {

          });
        };

        if (allVideosLoaded) {
          afterVideosLoaded();
        } else {
          this.hideLoader().then(() => {
            afterVideosLoaded();
          });
        }
      }).catch(this.onVideoLoadError);
    });
  }

  startTimer() {
    this.timerDuration = constants.TIMER_DURATION;
    this.timerStartTime = Date.now();
    this.timerFinished = false;
    this.addIsVisible(this.dom.timerEl).then(() => {
      this.renderTimer();
    });
  }

  renderTimer = () => {
    if (this.timerFinished) {
      return;
    }
    const {timerEl} = this.dom;
    const currTime = Date.now();
    const delta = currTime - this.timerStartTime;
    let elapsedSecs = Math.round((this.timerDuration - delta) / 1000);
    if (elapsedSecs < 0) {
      elapsedSecs = 0;
      this.timerFinished = true;
      this.onTimerFinished();
      this.removeIsVisible(timerEl, 1000);
      return;
    }
    if (elapsedSecs < 10) {
      elapsedSecs = `0${elapsedSecs}`;
    }

    timerEl.innerText = `00:${elapsedSecs}`;
    requestAnimationFrame(this.renderTimer);
  };

  onTimerFinished() {
    if (!this.mainActionStarted) {
      this.disableHamletItemSelection();
      this.removeIsVisible(this.dom.selectionSceneEl);
      this.playHamletWin();
    }
  }

  showLoader() {
    return new Promise((resolve) => {
      this.addIsVisible(this.dom.loaderEl).then(() => {
        resolve();
      })
    }).catch(error => console.error(error));
  }

  hideLoader() {
    return new Promise((resolve) => {
      this.removeIsVisible(this.dom.loaderEl).then(() => {
        resolve();
      })
    }).catch(error => console.error(error));
  }

  getVideoPath({
    type,
    kingItem,
    hamletItem,
  }) {
    const root = window.innerWidth > 980 ? constants.VIDOE_DESKTOP_PATH : constants.VIDOE_MOBILE_PATH;
    if (type === 'action') {
      return `${root}/action_${kingItem}_${hamletItem}.mp4`;
    } else {
      return `${root}/${type}_${kingItem}.mp4`;
    }
  }

  setPlayingVideo(video) {
    this.playingVideo = video;
    this.render();
  }

  render = () => {
    const {playingVideo} = this;
    [].forEach.call(document.querySelectorAll('video'), el => {
      if (el !== playingVideo) {
        el.style.display = 'none';
      }
    });

    if (playingVideo) {
      playingVideo.el.style.display = 'block';
      this.resizeAll();
    }
  };

  playHamletWin() {
    const video = new Video({filePath: this.getVideoPath({type: 'win', kingItem: this.kingItem})});
    video.load().then(() => {
      this.playingVideo.pause();
      this.setPlayingVideo(video);
      video.play();
      setTimeout(() => {
        this.onPlayHamletWinFinish();
      }, 7000);
    });
  }

  startAction() {
    const filePath = this.getVideoPath({
      type: 'action',
      kingItem: this.kingItem,
      hamletItem: this.hamletItem
    });

    this.timerFinished = true;
    this.mainActionStarted = true;
    this.removeIsVisible(this.dom.selectionSceneEl).then(() => {
      const isVideoAlreadyLoaded = this.loadedVideos[filePath];

      if (!isVideoAlreadyLoaded) {
        this.showLoader();
      }

      const video = new Video({filePath});

      video.load().then(() => {
        this.loadedVideos[filePath] = true;
        const afterVideoLoaded = () => {
          this.playingVideo.pause();
          this.setPlayingVideo(video);
          video.play().then(() => {
            this.onHamletLoseFinish();
          })
        };

        if (isVideoAlreadyLoaded) {
          afterVideoLoaded();
        } else {
          this.hideLoader().then(() => {
            afterVideoLoaded();
          });
        }

      });
    });
  }

  onPlayHamletWinFinish() {
    const {dom: {canvasEl, endSceneEl, endSceneTextEl}} = this;

    const finalText = this.generateFinalTextWin();
    endSceneTextEl.innerText = finalText;

    this.removeIsVisible(this.playingVideo.el).then(() => {
      this.addIsVisible(endSceneEl);
      this.resetToStartScene();
    });
  }

  onHamletLoseFinish() {
    const {dom: {canvasEl, endSceneEl, endSceneTextEl}} = this;
    this.playFinalSceneAudio();

    const finalText = this.generateFinalTextLose();
    endSceneTextEl.innerText = finalText;

    this.removeIsVisible(this.playingVideo.el).then(() => {
      this.addIsVisible(endSceneEl);
      this.resetToStartScene();
    });
  }

  resetToStartScene() {
    this.wasGameStarted = false;
    this.hamletItem = null;
    this.timerFinished = false;
    this.mainActionStarted = false;
  }

  playMenuSceneAudio() {
    if (!this.menuSceneAudio) {
      this.menuSceneAudio = new Audio('assets/music/main_menu_song.mp3');
      this.menuSceneAudio.loop = true;
    }
    this.menuSceneAudio.play();
  }

  playFinalSceneAudio() {
    if (!this.finalSceneAudio) {
      this.finalSceneAudio = new Audio('assets/music/final_song.mp3');
      this.finalSceneAudio.loop = false;
    }
    this.finalSceneAudio.play();
  }

  generateFinalTextLose() {
    const hamletItem = this.hamletItem;
    const kingItem = this.kingItem;
    let key;
    if (hamletItem) {
      key = `${kingItem}_${hamletItem}`;
    } else {
      key = kingItem;
    }
    return texts[key];
  }

  generateFinalTextWin() {
    return texts[this.kingItem];
  }
}

window.App = App;



/** WEBPACK FOOTER **
 ** ./src/client/index.js
 **/